import GridCellBase from '../GridCellBase';
import CellMlngEditorView from './CellMlngEditorView';
import store from '~system/vuex';

class CellMlngEditor extends GridCellBase {
  constructor(row, column, value, parentElement, propsData, dataset, grid) {
    super(row, column, value, parentElement, propsData, dataset, grid);

    // grid 에 조회된 다국어 값을 저장 할 map property를 추가
    if( !grid[column]){
      grid[column] = {};
    }
    // 기본 언어 정보를 조회
    if( !grid[column].langMasterInfo){
      this.getLangMaster().then(result => {
        grid[column].langMasterInfo = result;
        Object.freeze(grid[column].langMasterInfo);
      }).catch(err => console.log(err));
    }
    if( !grid[column].mlngInfoMap){
      grid[column].mlngInfoMap = new Map();
    }

    grid[column].multiLanguageIdField = propsData.multiLanguageIdField || 'multiLanguageId';

    this.setValue(value);
  }

  getBaseComponent() { // cell에 그려질 기본 컴포넌트를 반환
    return CellMlngEditorView;
  }

  refreshEditor(boundindex, column, value, parentElement) {
    this.refreshIndex = boundindex;
    this.setValue(value);
  }

  getEventName() { // 컴포넌트 데이터 변경을 감지할 이벤트 이름
    return 'mlng-changed';
  }

  decoratePropsData(row, column, value, propsData) { // 컴포넌트의 초기 props 설정
    this.grid.pageId = propsData.pageId;
  }

  setValue(value) { // 컴포넌트의 값을 변경 하는 함수
    if (this.getComponentInstance()) {
      if (utils.isEmpty(value) && this.grid[this.columnName].mlngInfoMap.has(this.getCurrentRowValue(this.grid[this.columnName].multiLanguageIdField))) {
        this.getComponentInstance().setValue(this.grid[this.columnName].mlngInfoMap.get(this.getCurrentRowValue(this.grid[this.columnName].multiLanguageIdField)),
        this.getCurrentDataRow() ? utils.clone(this.getCurrentDataRow()): '', utils.cloneDeep(this.grid[this.columnName].langMasterInfo));
      } else {
        this.getComponentInstance().setValue(value, this.getCurrentDataRow() ? utils.clone(this.getCurrentDataRow()):'', utils.cloneDeep(this.grid[this.columnName].langMasterInfo));
      }
    }
  }

  getValueFromEvent(event) { // 이벤트로부터 실제 dataset을 변경할 value 를 반환
    return event;
  }

  /**
   * override parent method
   * 컴포넌트에서 rest api를 호출할 경우 parent method 에서 setValue를 호출하여 전체 row를 다시 update 하고
   * 그 결과로 component를 다시 mount 하여 성능 문제가 발생하는 것을 방지
   */
  /*
  updateDataset(event) {
    const value = this.getValueFromEvent(event)
    const rowIndex = this.getDatasetIndex();
    // 언어값이 비어있을 경우 global 언어값으로 자동 채움
    let globalLang = utils.find(value,{langId: store.getters.userInfo.globalLangId});
    utils.forEach(value,itm => {
      // 언어값이 비어있을 경우
      if(utils.isEmpty(itm.multiLanguageContent)){
        itm.multiLanguageContent = globalLang.multiLanguageContent;
      }
    });
    this.dataset.setDataAsync(rowIndex, this.columnName, value);  
  }
  */

  bindEvents() {
    super.bindEvents();
    if (this.getComponentInstance()) {
      this.getComponentInstance().$on('service-queried', this.addMlngInfo.bind(this));
      this.dataset.$on(this.dataset.EVENTS.RAW_DATA_CHANGED, this.onDatasetChanged.bind(this));
    }
  }

  onDatasetChanged(){
    if(this.grid[this.columnName] && this.grid[this.columnName].mlngInfoMap){
      this.grid[this.columnName].mlngInfoMap.clear();
    }
  }

  setFocus() {
    this.setFocusLocalTxtFld();
  }

  setFocusLocalTxtFld() {
    if (this.componentInstance)  {
      if (this.componentInstance.setFocusLocalTxtFld) {
        this.componentInstance.setFocusLocalTxtFld();
      }
    }
  }

  setFocusGlobalTxtFld() {
    if (this.componentInstance)  {
      if (this.componentInstance.setFocusGlobalTxtFld) {
        this.componentInstance.setFocusGlobalTxtFld();
      }
    }
  }

  /**
   * 언어 마스터 정보 가져와서 다국어 배열 셋팅하기
   * @function getLangMaster
   * @param {None}
   * @returns {Promise}
   */
  getLangMaster() {
    const that = this;

    return new Promise((resolve, reject) => {
      let mlngDtlList = [];
      http.request(this.grid.pageId, 'DTS_CMZ_00039', {
      }).then(res => {
        res.data.forEach(itm => {
          mlngDtlList.push({
            multiLanguageId: that.multiLanguageId,
            langId: itm.langId,
            langName: itm.langName,
            multiLanguageContent: '',
            multiLanguageAbbreviationContent: '',
            multiLanguageTypeCode: '',
          });
        });

        resolve(mlngDtlList);
      }).catch(err => {
        console.error(err);
        reject(err);
      });
    });
  }

  /**
   * 특정 다국어ID에 관련된 다국어정보를 grid의 맵 변수에 추가
   * @function addMlngInfo
   * @param {String} mlngId: 다국어ID
   * @param {Array} mlngInfo: Object Array
   * @returns {Map}
   */
  addMlngInfo(mlngInfo){
    let mlngId = this.getCurrentRowValue(this.grid[this.columnName].multiLanguageIdField);
    if (!utils.isEmpty(mlngId)){
      return this.grid[this.columnName].mlngInfoMap.set(mlngId, mlngInfo);
    }
  }

  /**
   * 매개변수로 넘어가는 key에 일치하는 포맷팅된 사용자명 문자열을 반환
   * @function getUserName
   * @param {Number} key: 데이터셋 row id
   * @returns {String} 포맷팅된 사용자명 문자열 or undefined
   */
  getMlngInfo(mlngId){
    return this.grid[this.columnName].mlngInfoMap.get(mlngId);
  }

  /**
   * 매개변수로 넘어가는 key에 일치하는 엔트리 존재유무를 true/false 로 반환
   * @function hasUserName
   * @param {Number} key: 데이터셋 row id
   * @returns {Boolean} true/false
   */
  hasMlngInfo(mlngId){
    return this.grid[this.columnName].mlngInfoMap.has(mlngId);
  }

  getCurrentRowValue(fieldName) {
    if (utils.isEmpty(this.getCurrentDataRow())) {
      return '';
    } else {
      return this.getCurrentDataRow()[fieldName];
    }
  }

}

export default CellMlngEditor;
